export default __webpack_public_path__ + "static/media/char_body_010.c6a3376c.png";